/**
 * Widget PostMessage Protocol (parent version)
 *
 * Utilities for parent to communicate with widget iframes.
 * Note: Widget-side utilities are in widget/shared/src/utils/widget-messaging.js
 */

/**
 * Messages that go from Parent to Widget
 */
export const PARENT_TO_WIDGET = {
  SET_SETTINGS: 'set-settings',
  SHOW: 'show',
  HIDE: 'hide',
  NAVIGATE_TO_PAGE: 'navigate-to-page',
  AUTO_FILL_TEST_DATA: 'auto-fill-test-data',
  RESET: 'reset',
};

/**
 * Messages that go from Widget to Parent
 */
export const WIDGET_TO_PARENT = {
  READY: 'ready',
  FORM_SUBMITTED: 'form-submitted',
  FORM_RESET: 'form-reset',
  PAGE_CHANGED: 'page-changed',
  ERROR: 'error',
};

/**
 * Send a message from parent to widget iframe
 * @param {HTMLIFrameElement} iframe - The widget iframe element
 * @param {string} message_type - Message type from PARENT_TO_WIDGET
 * @param {*} data - Optional data payload
 */
export function sendToWidget(iframe, message_type, data = null) {
  if (!iframe?.contentWindow) {
    //console.warn('[Widget Messaging] Invalid iframe provided');
    return;
  }

  const message = data !== null ? [message_type, data] : [message_type];
  iframe.contentWindow.postMessage(message, '*');
}

/**
 * Create a message handler for parent to listen to widget messages
 * @param {Object} handlers - Map of message types to handler functions
 * @returns {Function} Message handler function to attach to window
 */
export function createParentMessageHandler(handlers) {
  return function(event) {
    if (!event.data || !Array.isArray(event.data)) {
      return;
    }

    const [message_type, data] = event.data;

    const handler = handlers[message_type];
    if (handler) {
      handler(data);
    }
  };
}
